import gql from 'graphql-tag'

export default gql`subscription ($office_id: Int){
  notificationUpserted(office_id: $office_id){
    id
    subject
    message
    user{
      user_id
      first_name
      last_name
    }
    popup
    updated_at
    active
  }
}`